module.exports = __webpack_public_path__ + "img/img18.02728e58.png";